export default function getIgnoreCacheReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'GET_CACHE_IGNORE_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'GET_CACHE_IGNORE_ERROR':
            return {...state, ...{error: action.error}};

        case 'GET_CACHE_IGNORE_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}